export class SaleNoteFilter {
    limit?: number;
    offset?: number;
    documentType?: string;
    identityDocument?: string;
    contactEmail?: string;
    contactPhone?: string;
    contactAddress?: string;
    paymentMethod?: string;
    dispatchType?: string;

    // Officially confirmed fields
    customer?: string;
    vendorUsername?: string;
    partialOrderNumber?: string;
    saleEntity?: string;
    status?: string;
    fromDate?: string;
    toDate?: string;
    skuCode?: string;
}
